<span class="loader" [class]="classes" #spinner></span>
